export default __webpack_public_path__ + "static/media/kquiz.1dfc998a.png";